module.exports = __webpack_public_path__ + "static/media/etage.fd6ab9bf.svg";